import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const primary = palette('#12427F');
/**
 * Dark-scheme primary: the brand hue made vivid for contrast; mirrors
 * `--color-primary` in theme.css.
 */
const primaryDark = palette('#4D94FF');

/** Design tokens only: PrimeNG reads ripple, appendTo and inputVariant from `providePrimeNG`. */
export const appPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: { primary },
      dark: {
        primary: primaryDark,
        // Navy-tinted ramp replacing Aura's grey zinc, to match theme.css.
        surface: {
          0: '#f2f6fc', // {text.color}
          50: '#dbe3ef',
          100: '#c3cede',
          200: '#abb9cd',
          300: '#93a3bc',
          400: '#a3b1c8', // muted text — matches --color-muted
          500: '#7b89a3', // icons
          600: '#45526e', // input borders
          700: '#33405c', // panel borders — matches --color-border
          800: '#1c2740', // hover — matches --color-hover
          900: '#121b2c', // panels — matches --color-background-neutral
          950: '#070c16', // page/input background — matches --color-background
        },
      },
    },
  },
});
